import { useRef, useState } from "react";
import { Camera, ImagePlus } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Button } from "@/components/kit";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export default function TaskPhotoDialog({ task, onClose, onDone, busy }) {
  const cam = useRef();
  const gal = useRef();
  const [loading, setLoading] = useState(false);
  const pick = async (e) => {
    const f = e.target.files?.[0];
    e.target.value = "";
    if (!f) return;
    setLoading(true);
    try {
      const fd = new FormData();
      fd.append("file", f, f.name || "tarefa.jpg");
      const r = await api("/upload", { method: "POST", form: fd });
      onDone(r.path);
    } catch (err) {
      toast.error(err.message || "Falha ao enviar a foto");
    } finally {
      setLoading(false);
    }
  };
  return (
    <Dialog open={!!task} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-sm" data-testid="task-photo-dialog">
        <DialogTitle>Foto para concluir</DialogTitle>
        <DialogDescription>“{task?.title}” precisa de uma foto como comprovação.</DialogDescription>
        <input ref={cam} type="file" accept="image/*" capture="environment" hidden onChange={pick} data-testid="task-photo-camera-input" />
        <input ref={gal} type="file" accept="image/png,image/jpeg,image/webp" hidden onChange={pick} data-testid="task-photo-gallery-input" />
        <div className="flex flex-col gap-2">
          <Button icon={Camera} loading={loading || busy} onClick={() => cam.current.click()} data-testid="task-photo-camera-button">Tirar foto</Button>
          <Button variant="secondary" icon={ImagePlus} disabled={loading || busy} onClick={() => gal.current.click()} data-testid="task-photo-gallery-button">Escolher da galeria</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
